import { Question } from "./question"
import { User } from "./user"

export interface CircleMember {
  username: string
  external_id: string
  permission: string
}

export interface CircleItem {
  id: string
  pupil: User
  members: CircleMember[]
}

export interface CirclesResponse {
  count: number
  next: string | null
  previous: string | null
  results: CircleItem[]
}

export const CIRCLES_ZERO = {
  count: 0,
  next: null,
  previous: null,
  results: [],
}

export type CircleQuestionResponse = Question[]
